const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHightStability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5454 16.2602C22.3475 12.6458 28.8544 11.5264 34.8652 13.8686C42.367 16.7917 46.7881 24.2041 46.2542 31.8328",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1336 48.3957C24.6921 48.2146 23.2505 47.8548 21.8372 47.3045C12.6046 43.7065 8.03775 33.3052 11.6358 24.0727C12.2613 22.4665 13.0938 21.0014 14.0885 19.6963",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7403 12.7139L27.8314 18.6282C27.9067 19.0351 27.8126 19.456 27.5727 19.7923L25.4986 22.6895C25.3387 22.9129 25.1223 23.087 24.8731 23.1975L21.6772 24.6014C20.7859 24.9918 20.4849 26.1088 21.0587 26.8943L22.1099 28.3335C22.2651 28.5451 22.3615 28.792 22.3921 29.0531L22.8107 32.5829C22.8765 33.1426 23.2457 33.6176 23.7701 33.8222C24.485 34.0997 24.8801 34.8663 24.6943 35.6118L24.0665 38.1233C23.9348 38.6525 23.5303 39.0687 23.0059 39.2192L18.8082 40.4185C18.3543 40.5479 17.8675 40.4609 17.4866 40.181L17.0139 39.833C16.466 39.4309 16.252 38.7136 16.4895 38.0763L17.4748 35.419C17.7029 34.8028 17.5124 34.1114 16.9998 33.6999L14.6764 31.8374C14.1943 31.4494 13.992 30.8097 14.1684 30.2148L15.7181 24.9871C15.7957 24.7237 15.8028 24.4438 15.7346 24.1781L15.5535 23.4679C15.3677 22.7389 15.744 21.9817 16.4377 21.6901L17.9663 21.0457C18.7517 20.7141 19.1139 19.8041 18.7682 19.0233L17.543 16.2625",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5097 17.7561L33.2281 18.4522C32.7718 18.6991 32.4826 19.1694 32.4661 19.6868L32.3979 21.7421C32.3862 22.1184 32.2286 22.4758 31.9582 22.7369L30.7071 23.9597C29.9475 24.7005 30.2086 25.9774 31.1962 26.3631L32.7789 26.9792C33.0964 27.1039 33.4468 27.1109 33.7713 27.0027L36.7555 26.0056C37.548 25.7399 37.9572 24.8674 37.6515 24.0891L37.2987 23.1907C37.1012 22.6875 37.1976 22.1184 37.548 21.7092C37.9854 21.1989 38.0183 20.4558 37.6256 19.9078L36.3887 18.1864C35.9607 17.5891 35.154 17.4057 34.5097 17.7561Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4985 47.7795L29.8513 43.8005C29.9148 42.8904 30.371 42.0509 31.0977 41.5006L32.9061 40.1343C33.6797 39.5487 34.143 38.641 34.1595 37.6698L34.1689 37.1101C34.1924 35.8919 34.912 34.7937 36.022 34.2905L38.5994 33.1194C39.4507 32.7313 40.429 32.7407 41.2708 33.1452L44.7889 34.8925C44.7913 34.8925 42.5854 46.4438 29.4985 47.7795Z",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.37035 36.2922C-0.788457 22.22 8.43468 9.0273 22.1706 6.07129",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4028 3L23.2877 5.85254L20.4376 9.73745",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6323 6.48242C48.3988 10.1157 56.8177 23.8352 54.0451 37.6134",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9676 36.2988L53.8029 38.7234L51.376 34.5586",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5073 51.7427C32.9655 60.0769 17.019 57.8805 8.12744 46.9971",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65283 50.8628L7.42182 46.1055L12.1792 46.8721",
    stroke: "black",
    style: {
      stroke: "black",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHightStability);
export default __webpack_public_path__ + "static/media/icon-hight-stability.f1477ec6ef5fbbc4e9b44063804f8535.svg";
export { ForwardRef as ReactComponent };